document.addEventListener('DOMContentLoaded', function() {
  // 1. Element Selection & Setup
  const sectionContainer = document.querySelector('.commercial-immersion__container');
  const slides = document.querySelectorAll('.commercial-immersion__slide');
  const navItems = document.querySelectorAll('.commercial-immersion__nav-item');
  const navContainer = document.getElementById('commercialImmersionNav');
  const totalSlides = slides.length;
  
  if (totalSlides === 0 || !sectionContainer) return;

  let currentIndex = 0;
  let autoRotateTimer;
  let isSectionVisible = false;
  let userInteracted = false;
  let initialAnimationFired = false;
  const ROTATION_SPEED = 6000;

  // 2. Core Slider Logic
  function changeSlide(newIndex, isAuto = false) {
    if (!isAuto) {
      userInteracted = true;
      stopAutoRotation();
    }

    const currentSlide = document.querySelector('.commercial-immersion__slide.commercial-immersion__slide--active');
    
    // Update UI Navigation immediately
    navItems.forEach((item, index) => {
      item.classList.remove('commercial-immersion__nav-item--active', 'commercial-immersion__nav-item--animating', 'commercial-immersion__nav-item--static');
      
      if (index === newIndex) {
        item.classList.add('commercial-immersion__nav-item--active');
        item.classList.add(isAuto ? 'commercial-immersion__nav-item--animating' : 'commercial-immersion__nav-item--static');
        
        // FIX: Only scroll horizontally within the container to prevent vertical page jumps
        if (navContainer) {
          const scrollLeftPos = item.offsetLeft - (navContainer.clientWidth / 2) + (item.clientWidth / 2);
          navContainer.scrollTo({ left: scrollLeftPos, behavior: 'smooth' });
        }
      }
    });

    // Fade Out Current Slide
    if (currentSlide) {
      currentSlide.classList.remove('commercial-immersion__slide--fade-in');
      
      setTimeout(() => {
        currentSlide.classList.remove('commercial-immersion__slide--active');
        showNewSlide(newIndex, isAuto);
      }, 400); // Wait for CSS opacity fade
    } else {
      showNewSlide(newIndex, isAuto);
    }
  }

  function showNewSlide(index, isAuto) {
    const targetSlide = document.querySelector(`.commercial-immersion__slide[data-index="${index}"]`);
    if (targetSlide) {
      targetSlide.classList.add('commercial-immersion__slide--active');
      void targetSlide.offsetWidth; // Force DOM reflow
      targetSlide.classList.add('commercial-immersion__slide--fade-in');
    }
    
    currentIndex = index;

    if (isAuto && isSectionVisible && !userInteracted) {
      startAutoRotation();
    }
  }

  // 3. Auto-Rotation Timers
  function startAutoRotation() {
    clearTimeout(autoRotateTimer);
    if (!userInteracted && isSectionVisible) {
      autoRotateTimer = setTimeout(() => {
        changeSlide((currentIndex + 1) % totalSlides, true);
      }, ROTATION_SPEED);
    }
  }

  function stopAutoRotation() {
    clearTimeout(autoRotateTimer);
  }

  // 4. Viewport Observer (Starts animation only when visible)
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        isSectionVisible = true;
        
        // Kick off the very first animation visually if it hasn't happened yet
        if (!initialAnimationFired && !userInteracted && navItems.length > 0) {
          navItems[0].classList.add('commercial-immersion__nav-item--animating');
          initialAnimationFired = true;
        }
        startAutoRotation();
      } else {
        isSectionVisible = false;
        stopAutoRotation();
      }
    });
  }, { threshold: 0.3 }); // 30% of the section must be visible to trigger

  observer.observe(sectionContainer);

  // 5. Click events for the unified nav column
  navItems.forEach(item => {
    item.addEventListener('click', function() {
      if (currentIndex === parseInt(this.dataset.index)) return;
      changeSlide(parseInt(this.dataset.index), false);
    });
  });

  // 6. Video Modal Logic
  const modal = document.getElementById('commercialImmersionModal');
  const modalContent = document.getElementById('commercialImmersionModalContent');
  const closeBtn = document.getElementById('commercialImmersionModalClose');
  const mediaCards = document.querySelectorAll('.commercial-immersion__media-card');

  function openModal(videoSrc) {
    if (!videoSrc) return;
    
    // Create HTML5 Video Element
    modalContent.innerHTML = `
      <video controls autoplay class="commercial-immersion__video-element">
        <source src="${videoSrc}" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    `;
    modal.style.display = 'flex';
    void modal.offsetWidth; // reflow
    modal.classList.add('commercial-immersion__modal-overlay--active');
  }

  function closeModal() {
    modal.classList.remove('commercial-immersion__modal-overlay--active');
    setTimeout(() => {
      modal.style.display = 'none';
      modalContent.innerHTML = ''; // Instantly stops video
    }, 300);
  }

  mediaCards.forEach(card => {
    card.addEventListener('click', function() {
      userInteracted = true;
      stopAutoRotation();
      
      const currentActiveNav = document.querySelector('.commercial-immersion__nav-item.commercial-immersion__nav-item--active');
      if (currentActiveNav) {
          currentActiveNav.classList.remove('commercial-immersion__nav-item--animating');
          currentActiveNav.classList.add('commercial-immersion__nav-item--static');
      }
      
      openModal(this.dataset.videoSrc);
    });
  });

  closeBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', function(e) {
    if (e.target === modal) closeModal();
  });
});